/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { DatePicker } from '@americanexpress/dls-react';

const AdvFormDateSelectItem = React.memo(({ formField, pageData, setPageData }) => {
  const {
    id, value, readOnly,
  } = formField;

  const handleOnChange = (e) => {
    const updatedPageData = { ...pageData };
    updatedPageData.formFields[id].value = e;
    setPageData(updatedPageData);
  };

  return (
    <div>
      <DatePicker
        id={`${id}-advForm-drpicker`}
        date={value}
        placeholder="MM/DD/YYYY"
        buttonLabels={{
          calendarButton: `${id}-advForm-drpicker-button`,
          previousMonth: `${id}-advForm-drpicker-prevMonth`,
          nextMonth: `${id}-advForm-drpicker-nextMonth`,
        }}
        describedBy={`${id}-advForm-drpicker-input`}
        status="default"
        onDateChange={(_, d) => handleOnChange(d.dateString)}
        readOnly={readOnly}
      />
    </div>
  );
});

export default AdvFormDateSelectItem;
